import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Typography } from "@mui/material";
import Popover from "@mui/material/Popover";
import { useState } from "react";
import imgLogo from "../../../Assets/Image/i4.png";
import { Link } from "react-router-dom";

const CompanyCard = ({ img, title, text, logo, id, logo_text }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return (
    <div
      className="Custom_Card"
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
    >
      {/* <svg  
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}>
                <MoreHorizIcon/>
            </svg> */}
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ p: 1 }}>{title}</Typography>
      </Popover>
      <Link to={`/view-company/${id}`}>
        <div className="imgContain">
          <div className="Image_Box">
            <img src={img ? img : imgLogo} alt="avatar" />
          </div>
        </div>
        <h4>{title}</h4>
        <p>{text}</p>
      </Link>
    </div>
  );
};

export default CompanyCard;
